function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 4.12895L12.2215 3.90121C14.6871 1.36614 18.6965 1.36614 21.1621 3.90121C23.6126 6.42073 23.6126 10.4945 21.1621 13.014L13.4337 20.9601C12.6636 21.7519 11.3974 21.7695 10.6056 20.9994C10.5857 20.9799 10.5857 20.9799 10.5663 20.9601L2.83787 13.014C0.387375 10.4945 0.387375 6.42073 2.83787 3.90121C5.3035 1.36614 9.31287 1.36614 11.7785 3.90121L12 4.12895ZM19.7284 11.6195C21.4238 9.87627 21.4238 7.03877 19.7284 5.29557C18.048 3.56791 15.3355 3.56791 13.6552 5.29557L12.7168 6.26036C12.3242 6.66407 11.6757 6.66407 11.2831 6.26036L10.3447 5.29557C8.6644 3.56791 5.95186 3.56791 4.27153 5.29557C2.57608 7.03877 2.57608 9.87627 4.27153 11.6195L11.9999 19.5656L19.7284 11.6195Z",
  className: "svg-fill"
});

var SvgHeartOutline = function SvgHeartOutline(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeartOutline, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart-outline.4bd0b07b.svg";
export { ForwardRef as ReactComponent };